// extracted by mini-css-extract-plugin
export default {"menu-view__title":"w_cn my-2 p-2","menu-view__tile-row":"w_cp d-flex"};